import * as types from './actionTypes';
import { get3dAssets, getProducts } from './searchActions';
import * as apiStatusActions from './apiStatusActions';
import { assetEsSearchFields } from '../../Constants/Asset';
import axios from 'axios';
import { assetEsUrl, esApiKey, productEsUrl } from '../../Constants/Api';
import { productElasticSearchMatchFields } from '../../Constants/Products';

export function dispatchActionData(type, data) {
	return { type: type, data: data };
}

export function load3dAssetSearchData(asset3dData) {
	return { type: types.SET_ASSETS3D_DATA, data: asset3dData };
}

export function loadProductSearchData(productData) {
	return { type: types.SET_PRODUCTS_DATA, data: productData };
}
// results page search term
export function setResultsPageSearchTerm(searchTerm) {
	return function (dispatch) {
		dispatch(dispatchActionData(types.SET_RESULTSPAGE_SEARCHTERM, searchTerm));
	};
}

export function fetchAssetGridData(data, size, from, isBuyable, isArchived, tags) {
	return async function (dispatch) {
		if (data && data.length > 0) {
			try {
				const assets = await get3dAssets(data, size, from, isBuyable, isArchived, tags);
				dispatch(load3dAssetSearchData(assets));
			} catch (error) {
				console.log('error loading asset grid data', error);
			} finally {
				dispatch(apiStatusActions.closeBackDropOverlay());
			}
		} else {
			dispatch(setResultsPageSearchTerm(''));
			dispatch(resetResultsViewData());
		}
	};
}

export function fetchProductGridData(data, size, from, isBuyable) {
	return async function (dispatch) {
		if (data && data.length > 0) {
			try {
				const products = await getProducts(data, size, from, isBuyable);
				dispatch(loadProductSearchData(products));
			} catch (error) {
				console.log('error loading product grid data', error);
			} finally {
				dispatch(apiStatusActions.closeBackDropOverlay());
			}
		} else {
			dispatch(setResultsPageSearchTerm(''));
			dispatch(resetResultsViewData());
		}
	};
}

export function resetResultsViewData() {
	return function (dispatch) {
		dispatch(dispatchActionData(types.RESET_RESULTSVIEW_DATA));
	};
}
export function setAssetFilters(data) {
	return function (dispatch) {
		dispatch(dispatchActionData(types.SET_ASSET_FILTERS, data));
	};
}
export function setProductFilters(data) {
	return function (dispatch) {
		dispatch(dispatchActionData(types.SET_PRODUCT_FILTERS, data));
	};
}
export function setAssetFilterCount(data) {
	return function (dispatch) {
		dispatch(dispatchActionData(types.SET_ASSET_FILTER_COUNT, data));
	};
}
export function setProductFilterCount(data) {
	return function (dispatch) {
		dispatch(dispatchActionData(types.SET_PRODUCT_FILTER_COUNT, data));
	};
}
export function fetchAssetFilterCount(data) {
	return async function (dispatch) {
		const archivedCount = await getArchivedCount(data);
		const buyableCount = await getBuyableCount(data);
		dispatch(setAssetFilterCount({ archived: archivedCount, buyable: buyableCount }));
	};
}
export function fetchProductFilterCount(data) {
	return async function (dispatch) {
		const buyableCount = await getProdBuyableCount(data);
		dispatch(setProductFilterCount({ buyable: buyableCount }));
	};
}

const getFilterCount = (must, searchTerm, fields, url) => {
	const query = {
		track_total_hits: true,
		query: {
			bool: {
				must: {
					multi_match: {
						query: `${searchTerm}`,
						operator: 'AND',
						fields: fields,
					},
				},
				filter: {
					bool: {
						must: must,
					},
				},
			},
		},
	};
	return axios
		.get(`${url}/_search`, {
			headers: {
				Authorization: `ApiKey ${esApiKey}`,
			},
			params: {
				source: JSON.stringify(query),
				source_content_type: 'application/json',
			},
		})
		.then((response) => {
			const totalHits = response.data.hits.total.value;
			return totalHits;
		})
		.catch((error) => {
			throw error;
		});
};
// below method retrieves assets from ES asset index.
export const getProdBuyableCount = (searchQuery) => {
	const must = [];
	must.push({
		multi_match: {
			query: 'N',
			fields: ['product.isBuyable'],
		},
	});
	return getFilterCount(must, searchQuery, productElasticSearchMatchFields, productEsUrl);
};

// below method retrieves assets from ES asset index.
export const getArchivedCount = (searchQuery) => {
	const must = [];
	must.push({
		multi_match: {
			query: true,
			fields: ['archived'],
		},
	});
	return getFilterCount(must, searchQuery, assetEsSearchFields, assetEsUrl);
};

// below method retrieves assets from ES asset index.
export const getBuyableCount = (searchQuery) => {
	const must = [];
	must.push({
		multi_match: {
			query: 'N',
			fields: ['product.isBuyable'],
		},
	});
	return getFilterCount(must, searchQuery, assetEsSearchFields, assetEsUrl);
};
